import { zodResolver } from '@hookform/resolvers/zod';
import { Form } from 'gcs-common/design-system/ui/form';
import { useTicketDropzone } from 'gcs-common/hooks/useTicketDropzone';
import etsFormBackground from 'gcs-common/img/ets-form-background.png';
import { useForm, useWatch } from 'react-hook-form';
import { z } from 'zod';
import TicketCreationForm from '../TicketCreationForm/TicketCreationForm';
import TicketDragArea from '../TicketDragArea/TicketDragArea';

const TicketFormSchema = z.object({
  comment: z.string().trim().min(1),
  attachments: z.array(z.instanceof(File)).optional(),
  title: z.string(),
});

export type TicketCreationFormValues = z.infer<typeof TicketFormSchema>;

const TicketNew = () => {
  const form = useForm<z.infer<typeof TicketFormSchema>>({
    resolver: zodResolver(TicketFormSchema),
    defaultValues: {
      comment: '',
      attachments: [],
      title: '',
    },
  });

  const attachments = useWatch({ control: form.control, name: 'attachments' });
  const hasAttachments = attachments && attachments.length > 0;

  const { getRootProps, getInputProps, isDragActive } = useTicketDropzone({
    form,
    attachmentsField: 'attachments',
  });

  return (
    <div
      id="automated-qa-ticket-new-container"
      {...getRootProps()}
      className="flex h-full flex-grow flex-col justify-between"
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <TicketDragArea />
      ) : (
        <>
          {!hasAttachments && (
            <div className="m-auto">
              <div className="flex flex-col items-center">
                <img src={etsFormBackground} alt="Bild" />
                <p className="font-medium text-xl">Ein oder mehrere Bilder aus der Mediathek auswählen</p>
                <p className="text-base">
                  Wähle verständliche Fotos und ergänze nützliche Details im Chat-Eingabefeld für schnelle Hilfe.
                </p>
              </div>
            </div>
          )}

          <div className={`w-full bg-neutral-1 ${hasAttachments ? 'h-full' : ''}`}>
            <Form {...form}>
              <TicketCreationForm />
            </Form>
          </div>
        </>
      )}
    </div>
  );
};

export default TicketNew;
